export default __webpack_public_path__ + "static/media/14-ART-(5-4).8431ad5e.jpg";